<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>
  <app-page-hero eyebrow="Warehousing" [title]="scanTitle()" [subtitle]="transfer?.transferNumber || 'Transfer scan workflow'">
    <div actions class="flex gap-2">
      <p-button label="Back to Transfer" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" [routerLink]="['/warehousing/transfers/view', transfer?.id]" queryParamsHandling="preserve"></p-button>
    </div>
  </app-page-hero>

  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

  <app-page-form-section [title]="receiptMode ? 'Destination Receipt Scan' : 'Outbound Unit Scan'" subtitle="Scan reserved stock-unit barcodes to update the transfer workflow.">
    @if (!supportsStockLedgerWorkflow()) {
      <div class="surface-100 border-round p-3 text-700">
        Third-party virtual warehouses do not support stock-ledger transfer scan workflows.
      </div>
    } @else if (receiptMode && !canReceive()) {
      <div class="surface-100 border-round p-3 text-700 flex flex-column gap-3">
        <span>{{ receiptBlockedMessage() }}</span>
        @if (canConfirmDispatch()) {
          <div>
            <p-button
              label="Confirm Dispatch"
              icon="pi pi-send"
              severity="success"
              [outlined]="true"
              [loading]="isScanning"
              [disabled]="isScanning"
              (click)="confirmDispatch()"></p-button>
          </div>
        }
      </div>
    } @else {
    @if (receiptMode && requiresReceiptZoneSelection()) {
      <div class="formgrid grid align-items-end mb-3">
        <div class="field col-12 md:col-8">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select
                inputId="receiptZoneId"
                [options]="receiptZoneOptions()"
                optionLabel="name"
                optionValue="id"
                [(ngModel)]="selectedReceiptZoneId"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                [disabled]="isScanning"
                styleClass="w-full"></p-select>
              <label for="receiptZoneId">Receipt Zone</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4 text-700">
          Choose the destination zone for units on this transfer before scanning receipt.
        </div>
      </div>
    }
    @if (!receiptMode) {
      <div class="flex flex-wrap gap-2 mb-3">
        <p-button label="Pick" icon="pi pi-check-circle" [outlined]="scanMode !== 'pick'" (click)="setScanMode('pick')"></p-button>
        <p-button label="Stage" icon="pi pi-warehouse" [outlined]="scanMode !== 'stage'" (click)="setScanMode('stage')"></p-button>
        <p-button label="Load" icon="pi pi-truck" [outlined]="scanMode !== 'load'" (click)="setScanMode('load')"></p-button>
      </div>
    }
    <div class="formgrid grid align-items-end">
      <div class="field col-12 md:col-8">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-barcode"></i></p-inputGroupAddon>
          <p-iftaLabel><input id="scanValue" pInputText [(ngModel)]="scanValue" (keyup.enter)="submitScan()" [disabled]="isScanning" autofocus><label for="scanValue">Stock Unit Barcode</label></p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-button [label]="scanActionLabel()" icon="pi pi-check" [loading]="isScanning" [disabled]="!scanValue || isScanning || (receiptMode && requiresReceiptZoneSelection() && !selectedReceiptZoneId)" (click)="submitScan()"></p-button>
      </div>
    </div>
    }
  </app-page-form-section>

  <app-page-form-section title="Reserved Units" subtitle="Outbound scans must be pick, stage, load; receipt scan updates the same unit at destination.">
    <p-table [value]="reservationRows()" styleClass="p-datatable-sm p-datatable-gridlines warehousing-data-table" [tableStyle]="{ 'min-width': '64rem' }">
      <ng-template pTemplate="header"><tr><th>Unit</th><th>Item</th><th>Qty</th><th>Source</th><th>Destination</th><th>Outbound</th><th>Receipt</th><th>Picked</th><th>Staged</th><th>Loaded</th><th>Received</th></tr></ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td><span class="warehousing-code-pill">{{ row.reservation.stockUnitCode || ('Unit #' + row.reservation.stockUnitId) }}</span></td>
          <td>{{ itemName(row.itemId) }}</td>
          <td>{{ row.reservation.quantity || 0 }}</td>
          <td>{{ masterName('ZONE', row.sourceZoneId) }} / {{ masterName('ITEM_CONDITION', row.sourceConditionId) }}</td>
          <td>{{ masterName('ZONE', row.destinationZoneId) }} / {{ masterName('ITEM_CONDITION', row.destinationConditionId) }}</td>
          <td><p-tag [value]="row.reservation.scanStatus || 'PENDING'" [severity]="statusSeverity(row.reservation.scanStatus)"></p-tag></td>
          <td><p-tag [value]="row.reservation.receiptStatus || 'PENDING'" [severity]="statusSeverity(row.reservation.receiptStatus)"></p-tag></td>
          <td>{{ displayDateTime(row.reservation.pickedAt) }}</td>
          <td>{{ displayDateTime(row.reservation.stagedAt) }}</td>
          <td>{{ displayDateTime(row.reservation.loadedAt) }}</td>
          <td>{{ displayDateTime(row.reservation.receivedAt) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="11">No reserved stock units yet.</td></tr></ng-template>
    </p-table>
  </app-page-form-section>
</app-page-shell>
